import { FC, useEffect } from "react";
import {
  CheckAuthentication,
  UpdateUserLastActionDate,
} from "../../helper/ui/methods";
import { useAppStateContext } from "../../middleware/context/state-context-provider";
import MainNavigationPanel from "../ui/user/main-navigation-panel";
import MainFooterPanel from "../ui/user/main-footer-panel";

export const AboutUs: FC = () => {
  const [state, dispatch] = useAppStateContext();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      UpdateUserLastActionDate(state.user, dispatch);
    }
  }, [state.user]);

  return (
    <>
      {(() => {
        return (
          <div
            id="pageWrapper"
            onClick={
              state.user
                ? () => UpdateUserLastActionDate(state.user!, dispatch)
                : undefined
            }
          >
            <MainNavigationPanel user={state.user} />
            <div id="contentWrapper">
              <div id="content" className="pageSurface">
                <div id="informationCanvas">
                  <h1>About Us</h1>
                  <h3>Welcome to Digital Charcoal</h3>
                  <p>
                    At Digital Charcoal, we are driven by a passion for
                    innovation and advancing the AEC industry. Founded in 2023
                    by{" "}
                    <a
                      href="https://www.linkedin.com/in/arash-naderpour-564b64132"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Arash Naderpour
                    </a>
                    , our mission is to revolutionize the construction process
                    and enhance VDC (Virtual Design and Construction) workflows
                    by developing and introducing digital tools and technologies
                    that simplify complex tasks and automate routine activities.
                  </p>
                  <h3>Our Journey</h3>
                  <p>
                    Digital Charcoal began as a one-person initiative, with
                    NavisCustomReportPro, now Charvue in our ForgeLine plugin,
                    as its first official product. This
                    innovative tool was designed to empower Navisworks users by
                    enabling them to create custom reports and extract valuable
                    data from their models. The success of NavisCustomReportPro
                    inspired us to broaden our product offerings and services.
                    Today, Digital Charcoal provides a diverse range of
                    solutions tailored to meet the needs of architects,
                    engineers, contractors, and owners.
                  </p>
                  <h3>What We Do</h3>
                  <p>
                    At Digital Charcoal, we specialize in developing
                    cutting-edge digital tools and solutions for the AEC
                    industry, including custom reporting software and advanced
                    data extraction tools. Our team leverages innovative
                    technologies and user-centric methodologies to deliver
                    high-quality, reliable products and services. Each solution
                    is designed with a focus on innovation, efficiency, and ease
                    of use, empowering architects, engineers, contractors, and
                    owners to streamline their workflows and achieve their
                    project goals.
                  </p>
                  <h3>Our Team</h3>
                  <p>
                    Digital Charcoal is currently a one-person company, but we
                    are excited about expanding our team in the near future to
                    support our growing vision and capabilities.
                  </p>
                  <h3>Why Choose Us?</h3>
                  <p>
                    Choosing Digital Charcoal means partnering with a company
                    that values strong customer relationships, embraces
                    innovation, and is committed to delivering practical and
                    sustainable solutions. We take pride in our dedication to
                    user-focused design, exceptional service, and creating
                    products that truly empower professionals in the AEC
                    industry.
                  </p>
                  <h3>Our Promise</h3>
                  <p>
                    We promise to deliver innovative solutions, reliable
                    performance, and outstanding customer support. Your
                    satisfaction is our top priority, and we are dedicated to
                    going above and beyond to exceed your expectations.
                  </p>
                  <h3>Get in Touch</h3>
                  <p>
                    Join us on our mission to revolutionize the AEC industry by
                    simplifying complex processes and enhancing efficiency
                    through innovative digital solutions. Contact us for more
                    information about our products and services, or to get
                    started on your project. Let’s build something extraordinary
                    together.
                  </p>
                </div>
              </div>
            </div>
            <MainFooterPanel />
          </div>
        );
      })()}
    </>
  );
};
